import AsyncStorage from '@react-native-async-storage/async-storage';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';

import AuthReducer from '../reducers/Auth.reducer';
import CommonReducer from '../reducers/Common.reducer';
import FormsReducer from '../reducers/Forms.reducer';
import UserReducer from '../reducers/User.reducer';

const authPersistConfig = {
	key: 'usersReducer',
	storage: AsyncStorage,
};

const rootReducer = combineReducers({
	forms: FormsReducer,
	auth: persistReducer(authPersistConfig, AuthReducer),
	user: UserReducer,
	common: CommonReducer,
});

export default rootReducer;
